import { Controller } from '@hotwired/stimulus'
import './idea_component.scss'

export default class extends Controller {}
